module.exports = __webpack_public_path__ + "static/NM-51bdf9ee6ec6bdb4d1f14a7272f536ec.png";